import React from "react";
import cx from "classnames";
import Widget from "./Widget";

function RestrictedWidget({ isDarkMode, ...props }) {
  return (
    <Widget 
      {...props} 
      className={cx(
        "d-flex justify-content-center align-items-center widget-restricted",
        { "dark-mode": isDarkMode }
      )}
    >
      <div className="t-body scrollbox">
        <div className="text-center">
          <h1>
            <span className="zmdi zmdi-lock" />
          </h1>
          <p className={cx("text-muted", { "text-muted-dark": isDarkMode })}>
            This widget requires access to a data source you don&apos;t have access to.
          </p>
        </div>
      </div>
    </Widget>
  );
}

export default RestrictedWidget;
